export default {
  "fr": {
    "company_growth_id_list_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises en croissance"])},
    "company_growth_id_list_2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises en hypercroissance"])}
  },
  "en": {
    
  }
}